import { useEffect } from "react";
import { useKeycloak } from "@react-keycloak/web";

const Index = () => {
  const { keycloak } = useKeycloak();
  useEffect(() => {
    if (keycloak) {
      keycloak.login();
    }
  }, []);
  return null;
};

export default Index;
